import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'safeDate'
})
export class SafeDatePipe implements PipeTransform {
  transform(value: any, format= 'medium'): string {
    if (!value) {
      return '';
    }

    try {
      // Handle string dates that might be malformed
      if (typeof value === 'string') {
        // Check for malformed dates like "12-00-2025 00:00:00"
        if (value.includes('-00-') || value.includes('00:00:00')) {
          return '';
        }

        // Try to parse the date
        const date = new Date(value);
        if (isNaN(date.getTime())) {
          return '';
        }
        value = date;
      }

      // If it's already a Date object, check if it's valid
      if (value instanceof Date && isNaN(value.getTime())) {
        return '';
      }

      // Use the standard date pipe format
      const datePipe = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: format.includes('MMM') ? 'short' : '2-digit',
        day: '2-digit',
        hour: format.includes('HH') ? '2-digit' : undefined,
        minute: format.includes('mm') ? '2-digit' : undefined,
        second: format.includes('ss') ? '2-digit' : undefined
      });

      return datePipe.format(value);
    } catch (error) {
      console.warn('SafeDatePipe: Invalid date value:', value, error);
      return '';
    }
  }
}
